export default "__VITE_PUBLIC_ASSET__6f55b3e3__"